
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import {
  IVerifikation,
  VerifikationStatus,
} from '../../Queries/VerifikationQuery/VerifikationQuery';
import EDTypography from '../../../../../../../../../BaseComponents/Typography/EDTypography';

interface IProps {
  verifikation: IVerifikation | undefined;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      headerContainer: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        color: theme.customProperties.Fade.LightOnDark.highEmphasis,
      },
      rowContainer: {
        display: 'flex',
        alignItems: 'baseline',
        [theme.breakpoints.down('sm')]: {
          display: 'block',
        },
      },
      text: {
        display: 'inline',
      },
      infoText: {
        marginRight: '15px',
      },
      DBText: {
        textTransform: 'capitalize',
      },
    } as const)
);

const statusTexts: { [key in VerifikationStatus]: string } = {
  SKAPAD: 'Skapad',
  DEFINITIVBOKFORD: 'Definitivbokförd',
  BACKAD: 'Backad',
  BOKFORINGSUNDERLAG_SKAPAT: 'Bokföringsunderlag skapat',
  KONVERTERAD: 'Konverterad',
  FELAKTIG_JOURNAL__SKALL_BACKAS: 'Felaktig journal. Skall backas',
  LAST: 'Låst',
};
const statusText = (status: VerifikationStatus | 'loading') => {
  if (status === 'loading') {
    return '...';
  }

  return statusTexts[status];
};

/**
 * Header med information om en verifikation
 */
const VerifikationHeader = (props: IProps) => {
  const { verifikation } = props;
  const { classes, cx } = useStyles();

  let bokforingsDatum = '...';
  let bokfordAv = '...';
  let bokforingsGrupp = '...';
  let status: VerifikationStatus | 'loading' = 'loading';
  let enhet = '...';
  let journalNummer = '...';
  if (verifikation != null && verifikation.info != null) {
    const { info } = verifikation;
    bokforingsDatum = info.bokforingsDatum.value;
    bokfordAv = info.bokfordAv.value;
    bokforingsGrupp = info.bokforingsGrupp.value;
    status = info.status.value;
    enhet = info.enhet.value;
    journalNummer = info.journalNummer.value;
  }
  return (
    <div className={classes.headerContainer}>
      <div className={classes.rowContainer}>
        <div>
          <EDTypography className={classes.text} bold color="inherit">
            Bokföringsdatum:{' '}
          </EDTypography>
          <EDTypography
            className={cx(classes.text, classes.infoText)}
            variant="body2"
            color="inherit"
          >
            {bokforingsDatum}
          </EDTypography>
        </div>
        <div>
          <EDTypography className={classes.text} bold color="inherit">
            Bokförd av:{' '}
          </EDTypography>
          <EDTypography
            className={cx(classes.text, classes.infoText)}
            variant="body2"
            color="inherit"
          >
            {bokfordAv}
          </EDTypography>
        </div>
        <div>
          <EDTypography className={classes.text} bold color="inherit">
            Journalnummer:{' '}
          </EDTypography>
          <EDTypography
            className={cx(classes.text, classes.infoText)}
            variant="body2"
            color="inherit"
          >
            {journalNummer}
          </EDTypography>
        </div>
      </div>
      <div className={classes.rowContainer}>
        <div>
          <EDTypography className={classes.text} bold color="inherit">
            Bokföringsgrupp:{' '}
          </EDTypography>
          <EDTypography
            className={cx(classes.text, classes.infoText)}
            variant="body2"
            color="inherit"
          >
            {bokforingsGrupp}
          </EDTypography>
        </div>
        <div>
          <EDTypography className={classes.text} bold color="inherit">
            Status:{' '}
          </EDTypography>
          <EDTypography
            className={cx(classes.text, classes.infoText)}
            variant="body2"
            color="inherit"
          >
            {statusText(status)}
          </EDTypography>
        </div>
        <div>
          <EDTypography className={classes.text} bold color="inherit">
            Enhet:{' '}
          </EDTypography>
          <EDTypography
            className={cx(classes.text, classes.infoText)}
            variant="body2"
            color="inherit"
          >
            {enhet}
          </EDTypography>
        </div>
      </div>
    </div>
  );
};

export default VerifikationHeader;
